import { render, staticRenderFns } from "./TopicView.vue?vue&type=template&id=3d4ab41f"
import script from "./TopicView.vue?vue&type=script&lang=js"
export * from "./TopicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports